import { Component, OnInit } from '@angular/core';
import {Toast} from 'angular-toastify/lib/toast';
import {ToastService} from 'angular-toastify';
import {OrdersService} from '../../services/orders.service';
import {Card, CardConversion, CardExtension} from "../../../dto/card";
import {CardsService} from '../../services/cards.service';
import {MatDialog} from '@angular/material/dialog';
import {ConfirmDialogComponent} from '../../../shared/confirm-dialog/confirm-dialog.component';
import {OrdersBadgeService} from "../../services/orders-badge.service";
import {DatePipe} from "@angular/common";
import {CardType} from "../../../dto/cardInfoModelBase";

@Component({
  selector: 'app-pending-conversions',
  templateUrl: './pending-conversions.component.html',
  styleUrls: ['./pending-conversions.component.css']
})
export class PendingConversionsComponent implements OnInit {
  pendingConversions: CardConversion[] = [];
  cardType = CardType;

  constructor(
    private toastService: ToastService,
    private ordersService: OrdersService,
    private cardsService: CardsService,
    private dialog: MatDialog,
    protected datePipe: DatePipe,
    private ordersBadgeService: OrdersBadgeService,
  ) { }

  ngOnInit(): void {

    this.loadPendingConversions();

  }


  loadPendingConversions() {
    this.ordersService.getCardsQueuedForConversion(true).subscribe(cards => {
      this.pendingConversions = cards;
    }, err => {
      this.toastService.error(err.error.message || err.error || err.message);
    });
  }

  executeConversions() {

    this.cardsService.executePendingConversions().subscribe(data => {

      this.toastService.info('Adding conversions for processing...');
      setTimeout(() => this.toastService.success('Conversions added for processing'), 3000);
      setInterval(this.loadPendingConversions, 5000);

      setTimeout(() => this.ordersBadgeService.clearCache(), 15000);

    }, err => {
      this.toastService.error(err.error.message || err.message || err.error || err);
    });



  }

  removeCardFromConversions(conversion: CardConversion) {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      data: {
        title: 'Remove card from conversion',
        text: 'Are you sure want to remove card '+conversion.card.token+' from the list of conversions? The card will be blocked from automatic conversion and will need to be converted manually if needed.'
      },
      minWidth: 350,
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result == 'ok') {
        this.cardsService.cancelCardConversion(conversion.card.token).subscribe(_ => {

          this.toastService.success('Card ' + conversion.card.token + ' has been removed');
          setTimeout(() => this.ordersBadgeService.clearCache(), 500);
          this.loadPendingConversions();

        }, err => {
          this.toastService.error(err.error.message || err.message || err.error || err);
        });
      }
    });
  }
}
